<!--走进资环/资质荣誉-->
<template class="carbon">
  <div style="font-family: Alibaba">
    <!--CP端-->
    <div class="PC_box">
      <!--插入头部-->
      <div>
        <keep-alive>
          <component class="walkinto" :is='components.tail'></component>
        </keep-alive>
      </div>

      <!--导航图-->
      <div>
        <el-carousel height="25vw" class='carousel_class'>
          <el-carousel-item v-for='item in honorlList' :key='item.id'>
<!--            <div @click='jump(item)'>-->
              <el-image
                style="width: 100%;height: 25vw"
                v-if='item.fullPathUrl != null'
                :src='item.fullPathUrl'
              />
<!--            </div>-->
          </el-carousel-item>
        </el-carousel>
      </div>
      <!--荣誉资质-->
      <div class='title'>
        <div>
          <h1>
            <i class="el-icon-caret-right"></i>{{ cnNameOne }}
          </h1>
          <p>{{ enNameOne }}</p>
        </div>
      </div>
      <!--荣誉资质-->
      <div class="box-width company">
        <div v-html="honorOne.content" class="htmlImgSize"></div>
      </div>

      <!--荣誉证书-->
      <div class='title'>
        <div>
          <h1>
            <i class="el-icon-caret-right"></i>{{ cnNameTwo }}
          </h1>
          <p>{{ enNameTwo }}</p>
        </div>
      </div>
      <el-row :gutter="20" class="box-width">
        <el-col :lg="8" :md="8"  :sm="12" :xs="24" v-for="item in honorTwo" :key="item.id" style="margin-bottom: 20px">
          <el-card shadow="hover" :body-style="{ padding: '0px' }"  style="text-align: center">
            <el-image
              style="height: 276px"
              alt="Image Description"
              v-if='item.fullPathUrl != null'
              :src='item.fullPathUrl'>
            </el-image>
          </el-card>
        </el-col>
      </el-row>

      <!--知识产权-->
      <div class='title'>
        <div>
          <h1>
            <i class="el-icon-caret-right"></i>{{ cnNameThree }}
          </h1>
          <p>{{ enNameThree }}</p>
        </div>
      </div>
      <!--资质荣誉-->
      <div class="box-width">
        <div class="honor">
          <el-carousel :interval="4000" type="card" height="600px" style="padding-top: 40px">
              <el-carousel-item class="carousel_item" v-for="item in honorThree" :key="item.id">
                <el-image
                  alt="Image Description"
                  v-if='item.fullPathUrl != null'
                  :src='item.fullPathUrl'>
                </el-image>
              </el-carousel-item>
          </el-carousel>
        </div>
      </div>

      <!--插入尾部-->
      <div>
        <keep-alive>
          <component  :is='components.tail1'></component>
        </keep-alive>
      </div>
    </div>

    <!--手机端-->
    <div class="mobile_box product">
      <!--插入头部-->
      <div>
        <keep-alive>
          <component :is='components.tail'></component>
        </keep-alive>
      </div>

      <div class='paddingS'>
        <!--占位div-->
        <div style='height: 72px'></div>

        <!--主图-->
        <div class="main_img">
          <el-carousel height="200px" class='carousel_class'>
            <el-carousel-item v-for='item in honorlList' :key='item.id'>
              <div>
                <el-image
                  :fit='fit'
                  v-if='item.fullPathUrl != null'
                  :src='item.fullPathUrl'
                />
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>

        <!--荣誉资质-->
        <div class="boxs_content">
          <div class='title'>
            <!--标题-->
            <div>
              <h1>
                <i class="el-icon-caret-right"></i>
                {{ cnNameOne }}
                <span>{{ enNameOne }}</span>
              </h1>
            </div>
            <!--内容-->
            <div>
              <div v-html="honorOne.content" class="htmlImgSize"></div>
            </div>
          </div>
        </div>

        <!--荣誉证书-->
        <div class="boxs_content">
          <div class='title'>
            <!--标题-->
            <div>
              <h1>
                <i class="el-icon-caret-right"></i>
                {{ cnNameTwo }}
                <span>{{ enNameTwo }}</span>
              </h1>
            </div>
            <!--走马灯-->
            <el-carousel>
              <el-carousel-item v-for="item in honorTwo" :key="item.id">
                <el-image
                  style="width: 100%"
                  alt="Image Description"
                  v-if='item.fullPathUrl != null'
                  :src='item.fullPathUrl'>
                </el-image>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <!--知识产权-->
        <div class="boxs_content">
          <div class='title'>
            <!--标题-->
            <div>
              <h1>
                <i class="el-icon-caret-right"></i>
                {{ cnNameThree }}
                <span>{{ enNameThree }}</span>
              </h1>
            </div>
            <!--走马灯-->
            <el-carousel height="120vw">
              <el-carousel-item v-for="item in honorThree" :key="item.id">
                <el-image
                  style="width: 100%"
                  alt="Image Description"
                  v-if='item.fullPathUrl != null'
                  :src='item.fullPathUrl'>
                </el-image>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <!--插入尾部-->
        <div>
          <keep-alive>
            <component  :is='components.tail1'></component>
          </keep-alive>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import header from '../components/header.vue'
import footer from '../components/footer.vue'
import { findBanner, findEnName, findHonorOne, findHonorThree, findHonorTwo } from '@api/zh'

export default {
  data () {
    return {
      tabId: null,
      components: {
        tail: header,
        tail1: footer
      },
      enNameOne: '',
      enNameTwo: '',
      enNameThree: '',
      cnNameOne: '',
      cnNameTwo: '',
      cnNameThree: '',
      activeName: 'second',
      fit: 'cover',
      url: require('@assets/images/aboutZh/zs3.png'),
      url1: require('@assets/images/aboutZh/jishu.jpg'),
      honorlList: [],
      honorOne: {},
      honorTwo: [],
      honorThree: []
    }
  },
  created () {
    this.tabId = this.$route.query.tabId
    this.selectBanner()
    this.selectEnName()
  },
  mounted () {
  },
  methods: {
    jump (raw) {
      if (raw.newsId === undefined || raw.newsId === '' || raw.newsId === null) {
      } else {
        this.$router.push({
          path: '/textContent',
          query: {
            id: raw.newsId,
            type: 2
          }
        })
      }
    },
    /** 轮播图 */
    selectBanner () {
      let that = this
      findBanner(this.tabId).then(res => {
        that.honorlList = res.data
      })
    },
    /** 查询英文名称 */
    selectEnName () {
      let that = this
      findEnName(this.tabId).then(res => {
        let data = res.data
        that.enNameOne = data[0].enName
        that.cnNameOne = data[0].cnName
        that.selectHonorOne(data[0].id)

        that.enNameTwo = data[1].enName
        that.cnNameTwo = data[1].cnName
        that.selectHonorTwo(data[1].id)

        that.enNameThree = data[2].enName
        that.cnNameThree = data[2].cnName
        that.selectHonorThree(data[2].id)
      }).catch(error => {
        console.error('Error fetching English names:', error)
      })
    },
    async selectHonorOne (enNameId) {
      let that = this
      await findHonorOne(enNameId).then(res => {
        that.honorOne = res.data
      })
    },
    async selectHonorTwo (enNameId) {
      let that = this
      await findHonorTwo(enNameId).then(res => {
        that.honorTwo = res.data
      })
    },
    async selectHonorThree (enNameId) {
      let that = this
      console.log("selectHonorThreeselectHonorThreeselectHonorThreeselectHonorThree")
      await findHonorThree(enNameId).then(res => {
        that.honorThree = res.data
      })
    },
    /** tab */
    handleClick (tab, event) {
      console.log(tab, event)
    }
  }
}
</script>

<style scoped>
::v-deep .htmlImgSize img {
  max-width: 100%;
  height: auto;
}
</style>
